import styled from 'styled-components';

const Wrapper = styled.div`
  background: #d01c2e;
  border-top-left-radius: 100px;
  border-bottom-left-radius: 100px;
  padding: 0 6px 0 7px;

  font-size: 10px;
  line-height: 24px;
  color: #fff;
  position: absolute;
  right: 0;
  top: 40px;
`;

export const ExpiredBanner = () => {
  return <Wrapper>Expired</Wrapper>;
};
